import { Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import React from 'react';
import { t } from '../constants/translations';
import { useLocale } from '../contexts/locale.context';
import PrimaryButton from './PrimaryButton';

interface Props {
  open: boolean;
  onClose: () => void;
  title: string;
  text?: JSX.Element;
  onSubmit: () => void;
  submitButtonTitle?: string;
  cancelButtonTitle?: string;
}

function Confirmation(props: Props) {
  const { lang } = useLocale();

  return (
    <Dialog open={props.open} onClose={props.onClose}>
      <DialogTitle>{props.title}</DialogTitle>

      {props.text && <DialogContent>{props.text}</DialogContent>}

      <DialogActions>
        <PrimaryButton onClick={props.onClose} color="primary">
          {props.cancelButtonTitle || t.no[lang]}
        </PrimaryButton>
        <PrimaryButton onClick={props.onSubmit} color="primary" variant="contained">
          {props.submitButtonTitle || t.yes[lang]}
        </PrimaryButton>
      </DialogActions>
    </Dialog>
  );
}

export default Confirmation;
